import Modal from "common/component/model";
import Modals from "common/component/model/Plate";
import { useState } from "react";

// Separate data arrays for Publications and Patents
const publicationsYearsData = [
  {
    year: 2015,
    content:
      "V. Chandan, M. Jain, H. Khadilkar, Z. Charbiwala, A. Jain, S. Ghai, R. Kunnath and D.P. Seetharam. UrJar: A Device to Address Energy Povery using E-Waste - ACM e-Energy, July 2015.",
  },
  {
    year: 2014,
    content:
      "V. Chandan, M. Jain, H. Khadilkar, Z. Charbiwala, A. Jain, S. Ghai, R. Kunnath and D.P. Seetharam. UrJar: A Lighting Solution using Discarded Laptop Batteries - ACM Dev, December 2014.<br>M. Jain, H. Khadilkar, N. Sengupta, Z. Charbiwala, K.U. Tennakoon, R. Wahab, L. Silva and D.P. Seetharam. Collaborative Energy Conservation in a Microgrid, ACM Buildsys, Memphis, USA, November 2014.<br>H Khadilkar, V. Chandan, S. Kalra, S. Ghai, Z. Charbiwala, T. Ganu, R. Kunnath, L.C. Ming and D.P. Seetharam. DC Picogrids as Power Backups for Office Buildings, IEEE SmartGridComm, November 2014.<br>T. Wijaya, T. Ganu, D. Chakraborty, K. Aberer and D.P. Seetharam. Consumer segmentation and knowledge extraction from smart meter and survey data. SIAM SDM, October 2014.<br>H. Khadilkar, T. Ganu, Z. Charbiwala, C.M. Lim, S. Mathew, D.P. Seetharam. Algorithms for upgrading the resolution of aggregate energy meter data, ACM e-Energy, June 2014. (Best Paper Award)<br> V. Chandan, T. Ganu, T. K. Wijaya, M. Minou, G.D. Stamoulis, G.A. Thanos, D.P. Seetharam. iDR: Consumer and grid friendly demand response system, ACM e-Energy, June 2014.<br>T. Ganu, D. Rahayu, D.P. Seetharam, R. Kunnath, A.P. Kumar, V. Arya, S.A. Husain, S. Kalyanaraman. SocketWatch: An autonomous appliance monitoring system, IEEE Percom, April 2014.<br>C. Basu, A. Agrawal, J. Hazra, A.P. Kumar, D.P. Seetharam, J. Beland, S. Guillon, I. Kamwa, C. Lafond. Understanding events for wide-area situational awareness, ISGT North America, January 2014.",
  },
  {
    year: 2013,
    content:
      "C. Basu, J. Hazra, K. Das and D.P. Seetharam. Real-time Alarm Management System for Wide-Area Monitoring.<br> IEEE ISGT Asia, November 2013.C. Basu, K. Das, J. Hazra, and D.P. Seetharam. Enhancing Wide-Area Monitoring and Control with Intelligent Alarm Handling. IEEE ISGT Europe, October 2013.<br> D.P Seetharam, V. Arya, D. Chakraborty, Z. Charbiwala, T. Ganu, S. Ghai, J. Hazra, P. Kodeswaran, R. Mitra, B. Narayanaswamy and N. Sengupta. Cyber Physical Systems for Smarter Energy Grids: Experiences at IBM Research-India. Journal of the Indian Institute of Science 93(3), 541--552, September 2013.<br> J. Hazra, S. Roy, Z. Charbiwala, D.P. Seetharam, Y. Sabharwal, S. Husain and S. Mathew. Energy Delivery Networks. IEEE SmartGridComm, November 2013.<br> J. Hazra, K. Das, A. P. Kumar, B. Narayanaswamy and D.P. Seetharam. Optimal Utilization of Power Transformers Through Virtual Sensing. IEEE ISGT Europe 2013.<br> M. Jain, A. Agrawal, K. Truong and D.P. Seetharam. We are not in the loop: Resource Wastage and Conservation Attitude of Employees in Indian Workplace, ACM UBICOMP, September 2013.<br> T. Ganu, D.P. Seetharam, D. Sinha, V. Arya, R. Kunnath, J. Hazra, S.A. Husain, L. Silva, S. Kalyanaraman. nPlug: An Autonomous Peak Load Controller, IEEE Journal of Selected Areas in Communication (JSAC). July 2013.<br> D.P. Seetharam, A. Agrawal, T. Ganu, J. Hazra, V. Rajaraman and R. Kunnath. Hidden costs of power cuts and battery backups, ACM e-Energy, May 2013.<br> S.K. Ghai, Z. Charbiwala, R. Kunnath, S. Mylavarapu and D.P. Seetharam. DC Picogrids: A Case for Local Energy Storage for Uninterrupted Power to DC Appliances, ACM e-Energy, May 2013. (Best Paper Finalist)<br> Y. B. Shrinivasan, Mohit Jain, D.P. Seetharam, A. Choudhary, E.M. Huang, T. Dillahunt and J. Mankoff. Deep Conservation in Urban India and its Implications for the Design of Conservation Technologies, ACM CHI, May 2013.",
  },
  {
    year: 2012,
    content:
      "K. Kumar, M. Radhakrishnan, K. Sivalingam and D.P. Seetharam, M Karthick. Comparison of Publish-Subscribe Network Architectures for Smart Grid Wide Area Monitoring. IEEE SmartGridComm, November 2012.<br>N. Sengupta, K. Das, T.S. Jayram and D.P. Seetharam. Optimal Allocation of Land Area for a Hybrid Solar Wind Farm, IEEE SmartGridComm, November 2012.<br>J. Hazra, K. Das and D.P. Seetharam. Smart Grid Congestion Management through Demand Response. IEEE SmartGridComm, November 2012.<br>K. Das, J. Hazra, D.P. Seetharam, R.K. Reddi and A. K. Sinha. Real-time Hybrid State Estimation Incorporating SCADA and PMU Measurements, IEEE ISGT, October 2012.<br>R.K. Reddi, J. Hazra, K. Das, D.P. Seetharam, and A. K. Sinha. Power Grid Transient Stability Prediction Using Wide Area Synchrophasor Measurements, IEEE ISGT, October 2012.<br>D.P. Seetharam, T. Ganu and J. Basak. Sepia : A Self-Organizing Electricity Pricing System. IEEE PES ISGT Asia, November 2012.<br>T. Ganu, D.P. Seetharam, V. Arya, R. Kunnath, J. Hazra, S.A. Husain, L. Silva and S. Kalyanaraman. nPlug: A Smart Plug for Alleviating Peak Loads, ACM e-Energy, May 2012.<br>D. Rahayu, B. Narayanaswamy, S. Krishnaswamy, C. Labbé and D.P. Seetharam. Learning to Be Energy-Wise: Discriminative Methods for Load Disaggregation, ACM e-Energy, May 2012.<br>S.K Ghai, L.V Thanayankizil, D.P. Seetharam and D. Chakraborty. Occupancy Detection in Commercial Buildings using Opportunistic Context Sources. Work in Progress. IEEE Percom 2012.<br>L.V Thanayankizil, S.K Ghai, D. Chakraborty and D.P. Seetharam. Softgreen : Towards Energy Management of Green Office Buildings with Soft Sensors. IEEE COMSNETS E6, January 2012. (Best Paper Award)",
  },
  {
    year: 2011,
    content:
      "V. Arya, D.P. Seetharam, S. Kalyanaraman, K. Dontas, C. Pavlovski, S. Hoy and J. Kalagnanam. Phase Identification in Smart Grids. IEEE SmartGridComm 2011.<br>A. Mittal, J. Hazra, N. Jain, V. Goyal, D.P. Seetharam and Y. Sabharwal. Real Time Contingency Analysis for Power Grids, Europar 2011.<br>J. Hazra, K. Das, and D.P. Seetharam and A. Singhee, Stream computing based synchrophasor application for power grids, 1st International Workshop on High Performance Computing, Networking and Analytics for the Power Grid (ACM), 2011.<br>T. Bapat, N. Sengupta, S.K. Ghai, V. Arya, Y. Shrinivasan and D.P. Seetharam. User-sensitive Scheduling of Home Appliances. ACM SIGCOMM Green Networking Workshop 2011.<br>V. Arya, J. Hazra, P. Kodeswaran, D.P. Seetharam, N. Banerjee and S. Kalyanaraman. CPS-Net: In-network aggregation for synchrophasor applications, IEEE COMSNETS IAMCOM, January 2011.<br>Y. Srinivasan , S.K. Ghai, A. Mittal, D.P. Seetharam, J. Hazra and S. Kalyanaraman. Yupik - Intelligent consumption management, Interactive Demo in IEEE COMSNETS, January 2011.",
  },
  {
    year: 2010,
    content:
      "J. Hazra and D.P. Seetharam.A Network Congestion Management Approach Considering the Risk of Cascading Failures, IEEE Power Engineering Society Conference. 2010.<br>V. T. Chakaravarthy, V. Pandit, Y. Sabharwal and D.P. Seetharam. Varying Bandwidth Resource Allocation Problem with Bag Constraints. IEEE IPDPS 2010.",
  },
  {
    year: 2007,
    content:
      "D.P. Seetharam and R. Fletcher. Battery Powered RFID, ACM SenseID 2007, November 2007. The comparison of the different types of battery-powered RFID tags have been explored.",
  },
  {
    year: 2004,
    content:
      "D.P. Seetharam and S. Rhee. An efficient RNG for Low-power Sensor Networks, IEEE EmNets-I, November 2004.<br>S. Rhee, D.P. Seetharam and S. Liu. i-Beans: An Ultra-low Power Wireless Sensor Network, Demo, ACM MOBISYS, August 2004.<br>S. Rhee, D.P. Seetharam and S. Liu. Techniques for Reducing Power Consumption in Low-data Rate Wireless Sensor Networks. IEEE WCNC, March 2004.An accomplished leader with deep technical skills for designing innovative solutions and soft skills for commercializing those innovations.",
  },
  {
    year: 2003,
    content:
      "S. Rhee, D.P. Seetharam, S. Liu, N. Wang and J. Xiao. i-Beans: An Ultra-low Power Wireless Sensor Network, Interactive Poster in the Fifth UBICOMP, October 2003.<br>K. Larson, T. Lawrence, T. McLeish, D.P. Seetharam and H. Shrikumar. A Network for Customizable + Reconfigurable Housing, Home Oriented Informatics and Telematics (HOIT), April 2003.",
  },
  {
    year: 2002,
    content:
      "J. Lifton, D.P. Seetharam, M. Broxton, and J. Paradiso. Pushpin Computing System Overview: A platform for distributed, embedded, ubiquitous sensor networks, International Conference on Pervasive Computing, August 2002.<br>J. Mitteldorf, D. Croll, C. Ravela, D.P. Seetharam, R. Bell and D. Bocelli. On the Prudent Predator: Individual-based Modeling of Multilevel Selection and the Evolution of Predatory Restraint, International Conference on Complex Systems, June 2002.",
  },
  {
    year: 1999,
    content:
      "T. Doan, P. Haddawy, T. Nguyen, and D.P. Seetharam. A Hybrid Bayesian Network Modeling Environment, The National Computer Science and Engineering Conference (NCSEC), 1999.",
  },
];
const patentsYearsData = [
  {
    year: "10,630,099",
    content: "Reducing conversion losses and minimizing load via appliance level distributed storage",
  },
  { year: "10,359,775", content: "Managing electricity usage for an appliance" },
  { year: "10,304,099", content: "Vehicle-to-vehicle energy market system" },
  { year: "10,215,814", content: "System and method for cognitive alarm management for the power grid" },
  { year: "10,007,285", content: "Injecting electricity into a grid from distributed generation" },
  { year: "9,847,660", content: "Managing a picogrid with a computing device" },
  { year: "9,841,456", content: "Electric outage detection and localization" },
  { year: "9,748,771", content: "Plug arrangements for alleviating peak loads" },
  { year: "9,691,112", content: "Grid-friendly data center" },
  { year: "9,647,458", content: "Distributed phase balancing" },
  { year: "9,536,198", content: "Non-technical loss detection and localization" },
  { year: "9,465,376", content: "Managing electricity usage for an appliance" },
  { year: "9,343,904", content: "Power factor" },
  { year: "9,312,695", content: "Condition-based management of power transformers" },
  { year: "9,285,242", content: "Determining a connectivity model in smart grids" },
  { year: "9,165,092", content: "Wind farm layout in consideration of three-dimensional wake" },
  { year: "9,014,868", content: "Power factor" },
  { year: "8,825,416", content: "Systems and methods for phase identification" },
  { year: "8,738,546", content: "Self-organizing energy pricing" },
];

export const PublicationPage = ({}) => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedPlate, setSelectedPlate] = useState(null);
  const [activeSection, setActiveSection] = useState("publications");
  const openModal = (year) => {
    if (isPublications) {
      setSelectedYear(year);
    } else {
      setSelectedPlate(year);
    }
  };

  const [publicationsPage, setPublicationsPage] = useState(0);
  const [patentsPage, setPatentsPage] = useState(0);

  const isPublications = activeSection === "publications";
  const years: any = isPublications ? publicationsYearsData : patentsYearsData;

  const currentPage = isPublications ? publicationsPage : patentsPage;
  const setCurrentPage = isPublications ? setPublicationsPage : setPatentsPage;

  const YEARS_PER_PAGE = 4;

  const itemsPerPage = Math.ceil(years.length / YEARS_PER_PAGE);

  const startIndex = currentPage * YEARS_PER_PAGE;
  const endIndex = startIndex + YEARS_PER_PAGE;
  const yearsToShow = years.slice(startIndex, endIndex);

  const paginatedYears = yearsToShow.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

  // Determine if we can go left or right
  const canGoLeft = currentPage > 0;

  const canGoRight = endIndex < years.length;

  const goPrevPage = () => {
    if (canGoLeft) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const goNextPage = () => {
    if (canGoRight) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };
  const closeModal = () => {
    setSelectedYear(null);
  };

  const closeModals = () => {
    setSelectedPlate(null);
  };

  return (
    <section
      id="publications"
      className=" min-h-[1150px] ml-1  md:ml-6 2xl:ml-4 md:min-h-[1000px] mb-[20%] max-h-[1060px] "
    >
      <div className="flex flex-col ">
        <p className=" md:text-center text-[#454444]  leading-[30px]  w-[90%] lg:ml-4 ml-4 xl:text-center mt-4 text-justify">
          Deva has been granted 21 US patents and has co-authored and published 50+ papers in top research venues such
          as Springer-Nature, IEEE JSAC, IEEE IPDPS, ACM e-Energy, ACM CHI, ACM UBICOMP, ACM Buildsys, etc. As per
          Google Scholar, his works have received 1900+ citations with a h-index of 24. Three of his papers (published
          at ACM e-Energy 2014, ACM Buildsys 2014 and IEEE COMSNETS E6 2012) have been recognized with best paper
          awards.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-8">
          <button
            className={` rounded-2xl  font-semibold  xl:w-[15%] p-5 ${
              activeSection === "publications"
                ? "bg-secondary-color text-white"
                : " border-2 border-secondary-color text-secondary-color"
            }`}
            onClick={() => setActiveSection("publications")}
          >
            PUBLICATIONS
          </button>
          <button
            className={`p-5 rounded-2xl font-semibold    w-[45%] xl:w-[15%] md:w-[15%] ${
              activeSection === "patents"
                ? "bg-secondary-color text-white"
                : " border-2 border-secondary-color text-secondary-color "
            }`}
            onClick={() => setActiveSection("patents")}
          >
            PATENTS
          </button>
        </div>

        <div className="ml-4">
          {/* Title */}
          <h2 className="text-yellow-500 text-xl sm:text-2xl font-semibold mt-12 mb-2">
            {isPublications ? "List Of Publications" : "List Of Patents"}
          </h2>
          <hr className="border-2 border-black ml-1 w-20 mb-6 rounded-sm" />

          {/* Optional Publications Text */}
          {isPublications && (
            <p className="space-y-2 mt-4  text-[#454444]  leading-[30px]  text-justify] w-[90%] md:text-start xl:w-[90%]  ">
              Deva has been granted 21 US patents and has co-authored and published 50+ papers in top research venues
              such as Springer-Nature, IEEE JSAC, IEEE IPDPS, ACM e-Energy, ACM CHI, ACM UBICOMP, ACM Buildsys, etc. As
              per Google Scholar, his works have received 1900+ citations with a h-index of 24. Three of his papers
              (published at ACM e-Energy 2014, ACM Buildsys 2014, and IEEE COMSNETS E6 2012) have been recognized with
              best paper awards.
            </p>
          )}

          {/* Optional Patents Text */}
        </div>

        {/* Arrows + Year Buttons */}
        <div className="flex items-center md:mx-4  xl:justify-start  md:justify-center mt-8  ">
          {/* Left Arrow (always shown, but disabled if we can’t go left) */}
          <button
            onClick={() => canGoLeft && setCurrentPage((prev) => prev - 1)}
            disabled={!canGoLeft}
            className={`mr-4 mt-10 ${
              canGoLeft ? "cursor-pointer text-secondary-color" : "cursor-not-allowed  pointer-events-none"
            }`}
          >
            <svg className="w-[60px] h-11" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          {/* The 4 Years for This Page */}
          <div className="grid mb-20 md:mb-1  mt-12  grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-10 justify-items-center md:justify-items-start">
            {yearsToShow?.map((year) => (
              <button
                key={year.year}
                onClick={() => openModal(year)}
                className={`
      aspect-square w-28 md:w-[150px] xl:w-[200px] 2xl-[220px]    rounded-full flex flex-col items-center justify-center 
      text-sm md:text-lg font-bold 
      ${
        selectedYear === years.year || selectedPlate === years.year
          ? "bg-secondary-color text-white"
          : "bg-gray-200 text-secondary-color"
      }
    `}
              >
                {isPublications ? (
                  <>
                    <span>Published</span>
                    {year.year}
                  </>
                ) : (
                  <>
                    <span>Patent No.</span>
                    {year.year}
                  </>
                )}
              </button>
            ))}
          </div>

          {/* Right Arrow (always shown, but disabled if can’t go right) */}
          <button
            onClick={() => canGoRight && setCurrentPage((prev) => prev + 1)}
            disabled={!canGoRight}
            className={`ml-4 mt-10 cursor-pointer ${
              canGoRight ? " text-secondary-color" : "cursor-not-allowed  pointer-events-none"
            }`}
          >
            <svg
              className="w-[60px] h-10 text-primary-color"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>

      {/* Modal */}
      {selectedPlate && (
        <Modals visible={Boolean(selectedPlate)} closeModalHandler={closeModals} selectedYears={selectedPlate} />
      )}
      {selectedYear && <Modal visible={!!selectedYear} closeModalHandler={closeModal} selectedYear={selectedYear} />}
    </section>
  );
};
